import {combineReducers} from 'redux';
import Writ from './WritKey/Module';
import SelectWrit from './SelectWrit/Module';
import SelectDateFoodMeal from './SelectDateFoodMeal/Module';
import SelectReserveDateFoodMeal from './SelectReserveDateFoodMeal/Module';
import SelectUserShift from './SelectUserShift/Module';
import FamiliesNameModule from './FamiliesName/Module';
import SelectFoodMeal from  './SelectFoodMeal/Module'
import SelectSelfService from './SelectSelfService/Module'
import DepartmentList from './DepartmentList/Module'
import SelectProfiles from './Profile/Module'

const reducers = combineReducers({
  SelectWrit,
  SelectDateFoodMeal,
  SelectReserveDateFoodMeal,
  SelectUserShift,
  Writ,
  FamiliesNameModule,
  SelectFoodMeal,
  SelectSelfService,
  DepartmentList,
  SelectProfiles
});

export default reducers;
